import { useMutation } from "@shared/lib/hooks";
import { FinanceApprovalService } from "../services/FinanceApprovalService";
import { ToastService } from "@shared/lib/services";
import {
  FINANCE_APPROVAL_QUERY_KEY,
  FINANCE_APPROVAL_QUERY_KEY_ID,
  GST_INVOICES_QUERY_KEY,
} from "../constants";
import {
  BRIEF_LIST_QUERY_KEY,
  BRIEF_LOT_FACETS_QUERY_KEY,
} from "@entities/brief/lib/constants";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import {
  IBulkPaymentRequest,
  IGstFileUploadRequest,
} from "@shared/lib/types/finance";
import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";

export function useSendBulkAmountOTP(handleCallback: (token: string) => void) {
  const {
    mutate: sendBulkAmountOTP,
    isLoading: isSendingBulkAmountOTPLoading,
    isSuccess: isSendingBulkAmountOTPSuccess,
    variables,
  } = useMutation({
    mutationFn: () =>
      FinanceApprovalService.sendBulkPaymentsOtp().catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: true },

    onSuccess: (c, data) => {
      handleCallback(data.data.token);
    },
  });

  return {
    sendBulkAmountOTP,
    isSendingBulkAmountOTPLoading,
    isSendingBulkAmountOTPSuccess,
    variables,
  };
}
